import "@awesome.me/webawesome/dist/components/tooltip/tooltip.js";
import "@awesome.me/webawesome/dist/components/button/button.js";
import "@awesome.me/webawesome/dist/components/input/input.js";
import "@awesome.me/webawesome/dist/components/icon/icon.js";
import "@awesome.me/webawesome/dist/components/card/card.js";
import "@awesome.me/webawesome/dist/components/slider/slider.js";

import { App } from "./app/app.js";

export { IntroOverlay } from "ui/components/intro-overlay.js";
export { SlideshowState } from "core/slideshow-state.js";
export { SlideshowToolbar } from "ui/components/toolbar.js";
export { SlideshowView } from "ui/components/slideshow-view.js";
export { ThumbnailStrip } from "ui/components/thumbnail-strip.js";
export { ModalReload } from "ui/components/modal-reload.js";
export { SettingsStore } from "core/settings-store.js";
export { UpdateModal } from "ui/components/update-modal.js";
export { LoadingOverlay } from "ui/components/loading-overlay.js";

window.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("#app");
  new App(root);
});

if ("serviceWorker" in navigator) {
  const notifyUpdateAvailable = () => {
    document.dispatchEvent(new CustomEvent("pwa-update-available"));
  };

  // Reload once the new worker actually takes control, so the prompt's
  // "Reload Now" button reliably picks up the new version.
  let reloadingForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForUpdate) return;
    reloadingForUpdate = true;
    // Tell the next App instance (same tab) to skip the confirmation
    // modal and silently restore whatever directory was already loaded.
    sessionStorage.setItem("slidey-sw-update-reload", "1");
    window.location.reload();
  });

  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      // An update may already be waiting from a previous visit.
      if (registration.waiting && navigator.serviceWorker.controller) {
        notifyUpdateAvailable();
      }

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (
            newWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            notifyUpdateAvailable();
          }
        });
      });

      // Long-lived sessions won't naturally re-check for updates, so poll.
      setInterval(() => registration.update(), 60 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          registration.update();
        }
      });
    });
}
